import { render, staticRenderFns } from "./extra-mein-projekt.vue?vue&type=template&id=634df612&lang=pug&"
import script from "./extra-mein-projekt.vue?vue&type=script&lang=js&"
export * from "./extra-mein-projekt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports